import React, { useState } from 'react';
import Input from '../Components/Inputs/Input';
import { useForm } from 'react-hook-form';
import TextArea from '../Components/Inputs/TextArea';
import { translate } from '../Services/translation';
import { post } from '../Services/http';
import Icon from '../Components/Icon';
import { triggerToast } from '../Services/Toast.service';

type FormData = {
  name: string;
  subject: string;
  email: string;
  message: string;
};

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();

  const onSubmit = (data, e) => {
    post('/api/contact', data)
      .then(() => {
        reset();
        setEmailHasBeenSent(true);
      })
      .catch(async (err) => {
        try {
          await err.response.json().then((data) =>
            triggerToast({
              type: 'error',
              text:
                data?.error ??
                data ??
                translate('contact-form.message-error-text'),
              autoClose: false,
            })
          );
        } catch (error) {
          triggerToast({
            title: translate('contact-form.message-error-title'),
            type: 'error',
            text: translate('contact-form.message-error-text'),
            autoClose: false,
          });
        }
      });
  };
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h4 className="mb-4">{translate('contact-form.title')}</h4>
      <Input
        wrapperClassName="mb-4"
        inputSize="xlarge"
        showAnimatedLabel={true}
        inputState={errors.name ? 'error' : 'default'}
        label={translate('general.name')}
        type="text"
        helperText={
          errors.name && translate('contact-form.required-message')
        }
        {...register('name', { required: true })}
      />
      <Input
        wrapperClassName="mb-4"
        inputSize="xlarge"
        showAnimatedLabel={true}
        inputState={errors.subject ? 'error' : 'default'}
        label={translate('general.subject')}
        type="text"
        helperText={
          errors.subject && translate('contact-form.required-message')
        }
        {...register('subject', { required: false })}
      />
      <Input
        wrapperClassName="mb-6"
        inputSize="xlarge"
        inputState={errors.email ? 'error' : 'default'}
        showAnimatedLabel={true}
        label={translate('general.email')}
        type="email"
        helperText={
          errors.email && translate('contact-form.required-message')
        }
        {...register('email', { required: true })}
      />
      <TextArea
        inputSize="xlarge"
        inputState={errors.message ? 'error' : 'default'}
        wrapperClassName="mb-6"
        showAnimatedLabel={true}
        label={translate('general.message')}
        type="text"
        helperText={
          errors.message && translate('contact-form.required-message')
        }
        {...register('message', { required: true })}
      />
      <button
        className="btn btn--black btn--xlarge w-full"
        disabled={emailHasBeenSent}
        type="submit"
      >
        {emailHasBeenSent ? (
          <>
            {translate('contact-form.message-sent')}{' '}
            <Icon name="check" className="h-4 w-4" />
          </>
        ) : (
          translate('contact-form.submit')
        )}
      </button>
    </form>
  );
};

export default ContactForm;
